








import { Component, Vue } from 'vue-property-decorator'
import bus from '../bus'

@Component
export default class Search extends Vue {
  private title = ''

  search() {
    if (this.title) {
      bus.$emit('getBooks', this.title)
    }
  }
}
